module.exports = __webpack_public_path__ + "img/1-2.443d234c.svg";